var __jsx = React.createElement;
import React from 'react';
import { connect } from 'react-redux';
import ReviewsShared from '@spa/shared/components/Reviews';
import { showModalAction } from '@spa/shared/store/actions/modal';
import Separator from '@spa/shared/components/Unisystem/Separator';
import { modalIds } from '@spa/offer/components/Modals/modal-displayer';
var VISIBLE_REVIEWS = 3;
var Reviews = function Reviews(_ref) {
  var _bookingReviews$revie;
  var bookingReviews = _ref.bookingReviews,
    showReviewsModal = _ref.showReviewsModal;
  var items = bookingReviews === null || bookingReviews === void 0 ? void 0 : (_bookingReviews$revie = bookingReviews.review_aggregates) === null || _bookingReviews$revie === void 0 ? void 0 : _bookingReviews$revie.items;
  if (!(items !== null && items !== void 0 && items.length)) {
    return null;
  }
  var showMore = items.length > VISIBLE_REVIEWS;
  var reviews = showMore ? items.slice(0, VISIBLE_REVIEWS) : items;
  var handleShowMore = function handleShowMore() {
    return showReviewsModal(bookingReviews);
  };
  return __jsx(React.Fragment, null, __jsx(ReviewsShared, {
    bookingReviews: bookingReviews,
    reviews: reviews,
    showMore: showMore,
    handleShowMore: handleShowMore
  }), __jsx(Separator, null));
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var offerAggregate = _ref2.offer.offerAggregate;
  return {
    bookingReviews: offerAggregate === null || offerAggregate === void 0 ? void 0 : offerAggregate.booking_review_aggregate
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showReviewsModal: function showReviewsModal(bookingReviews) {
      return dispatch(showModalAction({
        modalId: modalIds.REVIEWS,
        bookingReviews: bookingReviews
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Reviews);